import React from 'react'
import ConnectedComponent from '../../../../shared/connecter/ConnectedComponent'
import { LevelContainer, ScoreContainer } from '../../containers/LevelContainer'

function Player (props) {
  /*const tag = props.player.image ?
      <span><div className="avatar" style={{backgroundImage:'url('+props.player.image+')'}}/>{props.player.name}</span> :
          <span>{props.player.name}</span>*/
  const tag = <span>{props.player.name}</span>
  return (<ScoreContainer className="name-wrapper">{tag}</ScoreContainer>)
}

export default class PlayerLevelComponent extends ConnectedComponent {

  constructor(){
    super()
    this.subscribe('players')
  }
  render(){

    const players = this.store.players.toJSON()
    const scores = players.map( player => <Player key={player.id} player={player}/>)

    return (<LevelContainer name="" className="player-row">{scores}</LevelContainer>)
  }
}


// WEBPACK FOOTER //
// ./src/game/level/components/types/PlayerLevelComponent.jsx